/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  platform: PropTypes.string,
  rule: PropTypes.object,
  content: PropTypes.objectOf(
    PropTypes.shape({
      components: PropTypes.object,
      tone: PropTypes.object,
    })
  ),
});
